import React, { Suspense } from "react";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import {
  useGetAllCourtsQuery,
  useUnlinkCourtMutation,
} from "../../lib/redux/services/sections/Courts";
import { Link, useNavigate, useParams } from "react-router-dom";
import Table from "../../components/custom/tableWrapper/Table";
import { DictionaryType, tableConfig } from "../../types";
import deleteIcon from "../../assets/icons/deleteRed.svg";
import editIcon from "../../assets/icons/EDIT ICON.svg";
import { toast } from "react-toastify";
import { toastMessage } from "../../utils/utils";
import Button from "../../components/global/Button";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import Loader from "../../components/skeletons/Loader";

const SeeAllCourts = () => {
  const { Auth, courts, shared }: DictionaryType = useGetDictionary();
  const { club_id } = useParams();
  const { data, isLoading } = useGetAllCourtsQuery({
    club_id: club_id ? +club_id : undefined,
  });
  const navigate = useNavigate();
  const [deleteCourt] = useUnlinkCourtMutation();

  const columns = [
    {
      title: courts.courts_table.court_name,
      tag: "name",
    },
    {
      title: courts.courts_table.court_type,
      tag: "court_type",
    },
    {
      title: courts.courts_table.privacy,
      tag: "privacy_options",
    },

    {
      title: "",
      tag: "delete_edit",
    },
  ];
  const config: tableConfig = {
    delete_edit: {
      isCustomViewChildren: true,
      customViewChildren: (row, tag) => {
        return (
          <td className="flex-1 p-4 ">
            <div className="flex flex-row gap-2  ">
              <img loading="lazy"
                src={deleteIcon}
                alt="delete"
                className="hover:cursor-pointer w-8"
                onClick={async () => {
                  await toast.promise(
                    deleteCourt(row.id).unwrap(),
                    toastMessage()
                  );
                }}
              />
              <a
                className=""
                href={`/auth/add-new-court-1/${club_id}/${row.id}`}
              >
                <img loading="lazy"
                  src={editIcon}
                  className="w-8 hover:cursor-pointer"
                  alt="edit"
                />
              </a>
            </div>
          </td>
        );
      },
    },
  };

  return (
    <AuthLayout>
      <div className="  flex flex-col gap-8 px-12 ">
        <div className="flex flex-col gap-5 text-center ">
          <PageTitle title={Auth?.add_new_court.add_new_court_title} />
        </div>
      </div>
      <div className="">
        <div className="  mx-40 fixed-table">
          {isLoading ? (
            <div className="h-[300px]">
              <Loader />
            </div>
          ) : (
            <Table
              columnsData={columns}
              //@ts-ignore
              rowData={data?.data}
              tbodyClassName="h-[300px] border-none"
              generalCellRowClassName="  min-w-[150px] w- overflow-hidden text-center "
              generalColumnsClassName="border-b-2  border-b-primary border-dotted text-center text-sm"
              generalRowClassName="border-none text-center text-sm  "
              config={config}
              theadClassName="!pr-0 !bg-white"
            />
          )}
        </div>

        <div className="flex flex-row justify-center items-center pt-4 gap-10 px-20">
          <Button
            customeStyle="bg-white text-red-500  w-full rounded-full  text-base py-2.5"
            href={`/auth/add-new-court-1/${club_id}`}
            text={shared.back}
            width="max-w-[400px] w-full"
          />

          <Button
            customeStyle="bg-primary text-white w-full rounded-full text-base py-2.5 border-primary border-2"
            text={shared.next}
            href="/auth/add-organization"
            width="max-w-[400px] w-full"
            type="button"
          />
        </div>
      </div>
    </AuthLayout>
  );
};

export default SeeAllCourts;
